<template>
  <div
    v-show="datas.length > 0"
    class="d-flex flex-wrap justify-content-center flex-column align-items-center"
  >
    <v-card
      flat
      v-for="(item, i) in datas"
      :key="i"
      color="transparent"
      class="d-flex"
    >
      <v-tooltip :key="i" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <div
              style="cursor: pointer"
              v-bind="attrs"
              v-on="on"
              class="qrBtn ma-2"
              :style="{
                background: item?.color ?? '',
                opacity: hover && item?.color?.length > 0 ? '.8' : '1',
              }"
              @click="openLink(item?.value)"
            >
              <v-img
                v-if="item?.images?.length > 0"
                :src="item?.images"
                height="50"
                width="50"
              />
              <component
                v-if="item?.svg?.length > 0"
                :is="item.svg"
                v-bind="hover ? item.attrs : ''"
                :height="item.height"
                :width="item.width"
              />
            </div>
          </v-hover>
        </template>
        <span>{{ item?.label }}</span>
      </v-tooltip>
    </v-card>
  </div>
</template>

<script>
import svgBazar from "../cm/svgBazar.vue";
import svgWhatsapp from "../../../../content/svgLoader/svgFile/svgWhatsapp.vue";
import SvgMyket from "../cm/svgMyket.vue";
import svgAppstore from "../cm/svgAppstore.vue";
import svgGoogleplay from "../cm/svgGoogleplay.vue";
import svgSamsungstore from "../cm/svgSamsungstore.vue";
import svgXhiame from "../cm/svgXhiame.vue";
import svgVivostore from "../cm/svgVivostore.vue";
import svgAmazonstore from "../cm/svgAmazonstore.vue";
export default {
  components: {
    svgBazar,
    svgWhatsapp,
    SvgMyket,
    svgAppstore,
    svgGoogleplay,
    svgSamsungstore,
    svgXhiame,
    svgVivostore,
    svgAmazonstore,
  },
  name: "applicationShow",
  props: {
    value: [Object],
  },

  computed: {
    datas() {
      let d = [];
      Object.keys(this.value).map((data) => {
        this.value[data].data?.map((item) => {
          if (item?.value?.length > 0) d.push(item);
        });
      });

      return d;
    },
  },

  methods: {
    openLink(url) {
      if (url) {
        // اطمینان از اینکه لینک کامل است
        const absoluteUrl =
          url.startsWith("http://") || url.startsWith("https://")
            ? url
            : `https://${url}`; // اگر پروتکل ندارد، https اضافه کن
        window.open(absoluteUrl, "_blank", "noopener,noreferrer");
      } else {
        console.error("No URL provided");
      }
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px !important;
  height: 130px !important;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}
</style>
